export default __webpack_public_path__ + "static/media/ListDots.f37398da.svg";